import React, { useEffect, useState } from "react";
import { Image, Row, Col, Table, Form } from "react-bootstrap";
import { DropDownButton } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import StatusFilter from "./Modals/StatusFilter";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { SeatingStatus } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import TableSizePopup from "../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
const ExpFilterSection = (props) => {


  const [isActive, setActive] = useState(false);
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [showstatus, setShowstatus] = useState("All");
  const [statusText, sestatustext] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodStatus, setPaymentMethodStatus] = useState("");
  const [expstatusvalues,setExpstatusValues]=useState('')
  const [open, setOpen] = useState(false);
  
  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    restaurantReverse: "",
    open: false,
    showStatus: "All",
    showStatusText: "",
    openPax: false,
    showPax: "All",
    showPaxText: "",
    showSearch: false,
  });

  /*********************************
   * @DESC Show Status Modal Action
   *********************************/
   const onOpenModal = () => {
    setState({ ...state, open: true });
  };
  const onCloseModal = () => {
    setState({ ...state, open: false });
  };
  const bigButtonShowStatusHandler = (e, type) => {
    console.log(type)
    e.preventDefault();
    setState({
      ...state,
      showStatusText: type,
    });
    if( props.seatingstatusValue){
    props.seatingstatusValue(type);
    }
  };
  const selectStatusClick = (e) => {
    setState({
      ...state,
      showStatus: state.showStatusText === "" ? "All" : state.showStatusText,
      open: false,
    });
    console.log(state.showStatus)
  //  props.seatingstatusValue(state.showStatus);
  };

  /*********************************
   * @DESC Show Pax Modal Action
   *********************************/
  const onOpenModalPax = (e) => {
    setState({
      ...state,
      openPax: true,
    });
  };
  const onCloseModalPax = (e) => {
    setState({
      ...state,
      openPax: false,
    });
  };
  const bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    setState({
      ...state,
      showPaxText: type,
    });
    if(props.seatingpaxvalue){
    props.seatingpaxvalue(type);
    }
  };

  const sendsearchvalue = (value) => {
    setSearch(value);
    if (props?.searchvalue) {
      props.searchvalue(value);
    }
  };

  useEffect(()=> {
    if(props.seatingpaymenttype){
      props.seatingpaymenttype(paymentMethod);
    }
  },[paymentMethod])

  useEffect(()=> {
    if(props.seatingpaymentStatus){
      props.seatingpaymentStatus(paymentMethodStatus);
    }
    if(props.expstatus){
      props.expstatus(expstatusvalues);
    }
  },[paymentMethodStatus,expstatusvalues])



  return (
    <>
      <div className="ExpfilterSection mt-2">
        <Row>
          <Col md={4} className="d-flex align-items-center ">
            <div
              className={`newexpandablesearch mx-2  mb-2 ${
                isActive ? "active" : null
              }`}
            >
              <div className="searchicon">
                <i
                  onClick={() => {
                    setActive(!isActive);
                  }}
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
              <div className="input">
                <Form.Control
                  type="text"
                  placeholder="Request Name,ID..."
                  className="newsearchinput"
                  value={search}
                  onChange={(e) => {
                    sendsearchvalue(e.target.value);
                  }}
                  style={{ borderRadius: "28px" }}
                />
                <i className="fa fa-timesw" aria-hidden="true"></i>
              </div>
            </div>
            <StatusFilter
              statusfilter={false}
              experiencestatus={history?.location?.pathname?.includes('pending') ? false : true}
              paymentTypeFilter={true}
              paymentMethodfilter={true}
              paymentMethodValues={(e) => {
                setPaymentMethod(e);
              }}
              paymentstatuvalues={(e) => {
                setPaymentMethodStatus(e);
              }}
              expstatusvalues={(e)=> {setExpstatusValues(e)}}
            />
            {props?.showdownloadBtn && (
              <>
               <div className="f10-400" align="center">
                  <img
                    src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                    width="80px"
                    alt="icon"
                    title="Download"
                />
              </div> 
              </>
            )}   
          </Col>
          <Col md={4} className="d-flex">
            <div className="row w-100 flexcenter">
              {props?.path?.includes("pending") ? null : (
                <>
                  <div
                className="col-6"
                style={{ borderRight: "1px solid #E0E0E0" }}
              >
                <SeatingStatus
                  status={state.showStatus}
                  onOpenModal={onOpenModal}
                  onCloseModal={onCloseModal}
                  open={state.open}
                  seatingStatus={state.showStatusText}
                  onClickAll={(e) => bigButtonShowStatusHandler(e, "All")}
                  onClickSeated={(e) => bigButtonShowStatusHandler(e, "Seated")}
                  onClickNonSeated={(e) =>
                    bigButtonShowStatusHandler(e, "Not Seated")
                  }
                  onStatusClick={onCloseModal}
                  displayNotSeatedButton={true}
                />
              </div>
                </>
              )}
            
              <div
                className="col-6"
                style={{ borderRight: "1px solid #E0E0E0" }}
              >
                <TableSizePopup
                  showPax={state.showPax}
                  onOpenModal={onOpenModalPax}
                  open={state.openPax}
                  onCloseModal={onCloseModalPax}
                  table_size={state.showPaxText}
                  onClickAll={(e) => bigButtonShowPaxHandler(e, "All")}
                  onClickTwo={(e) => bigButtonShowPaxHandler(e, "2")}
                  onClickFour={(e) => bigButtonShowPaxHandler(e, "4")}
                  onClickSix={(e) => bigButtonShowPaxHandler(e, "6")}
                  onClickEight={(e) => bigButtonShowPaxHandler(e, "8")}
                  graterThanEight={(e) => bigButtonShowPaxHandler(e, "8>")}
                  selectPaxClick={onCloseModalPax}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ExpFilterSection;
